module.exports = __webpack_public_path__ + "media/images/1782-1b67557b1fa13cdd42c39c5f9d9da60a.png";